import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../domain/repository/auth-service.abstract';

export const isAnonymousGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.isAuthenticated() ? router.createUrlTree(['/']) : true;
};
